/** @jsxImportSource @emotion/react */

import { CalendarOutlined, DownOutlined } from "@ant-design/icons";
import { Button } from "antd";
import DatePickerCustom from "components/Common/DatePickerCustom";
import SelectCustom from "components/Common/SelectCustom";
import { listCalendar } from "contants/list-calendar";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { theme } from "styles/theme";

import { TimeLineStyle } from "./index.style";

type State = {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  currentPage: number;
  idDate: string;
  visible: boolean;
  dataItem: any;
};

interface Props {
  idDate: string;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setState: any;
  isDisable: boolean;
  getDataWager: () => void;
  isLoading: boolean;
  handleSelectTime: (value: string) => void;
}

export const TimeLineSelectCustom: React.FC<Props> = ({
  idDate,
  startDate,
  setState,
  endDate,
  isDisable,
  getDataWager,
  isLoading,
  handleSelectTime,
}) => {
  const { t } = useTranslation([
    "betting",
    "button",
    "transaction",
    "placeholder",
  ]);
  const _setState = setState as React.Dispatch<React.SetStateAction<State>>;
  return (
    <>
      <SelectCustom
        defaultValue={idDate}
        onChange={handleSelectTime}
        options={listCalendar}
        suffixIcon={<DownOutlined css={TimeLineStyle.iconCalendar} />}
      />
      <div css={TimeLineStyle.fromGroupContainer}>
        <div css={TimeLineStyle.formGroup}>
          <span css={TimeLineStyle.spanDate(theme.colors.lightText)}>
            {t("transaction:StartDate")}{" "}
            <span css={TimeLineStyle.spanDate(theme.colors.darkGreen)}>*</span>
          </span>
          <DatePickerCustom
            value={startDate}
            placeholder={t("placeholder:SelectDate")}
            onChange={(val) => {
              if (val && val.isValid()) {
                // Kiểm tra nếu val hợp lệ
                _setState((prev) => ({
                  ...prev,
                  startDate: dayjs(val),
                }));
              } else {
                _setState((prev) => ({
                  ...prev,
                  startDate: null,
                }));
              }
            }}
            disabledDate={(current) => {
              return current > dayjs().endOf("day");
            }}
            suffixIcon={<CalendarOutlined css={TimeLineStyle.iconCalendar} />}
          />
        </div>

        <div css={TimeLineStyle.formGroup}>
          <span css={TimeLineStyle.spanDate(theme.colors.lightText)}>
            {t("transaction:EndDate")}{" "}
            <span css={TimeLineStyle.spanDate(theme.colors.darkGreen)}>*</span>
          </span>
          <DatePickerCustom
            value={endDate}
            placeholder={t("placeholder:SelectDate")}
            disabledDate={(current) => {
              return current > dayjs().endOf("day");
            }}
            onChange={(val) => {
              if (val && val.isValid()) {
                // Kiểm tra nếu val hợp lệ
                _setState((prev) => ({
                  ...prev,
                  endDate: dayjs(val),
                }));
              } else {
                _setState((prev) => ({
                  ...prev,
                  endDate: null,
                }));
              }
            }}
            suffixIcon={<CalendarOutlined css={TimeLineStyle.iconCalendar} />}
          />
        </div>
        <div css={TimeLineStyle.formSubmit}>
          <Button
            type="primary"
            size="large"
            css={TimeLineStyle.btnSubmit}
            htmlType="submit"
            disabled={!isDisable}
            onClick={getDataWager}
            loading={isLoading}
          >
            {t("button:Apply")}
          </Button>
        </div>
      </div>
    </>
  );
};
